export default __webpack_public_path__ + "static/Fintech-358df1ff59ce3102194a819977ecc1b5.png";